export default {
  mainTitle: {
    width: '250px',
    height: '30px',
    marginLeft: '8px',
    display: 'block'
  },
  dateCell: {
    width: '120px',
    textAlign: 'left'
  },
  date: {
    width: '40px'
  },
  title: {
    width: '40px'
  },
  titleCell: {
    textAlign: 'left'
  }
}
